/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { handleExistingCommentList } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { NDC_DETAILS_TAB_DATA, NDC_TABS_DATA } from '../utility/constants';
import * as TYPES from './types';

const intialState = {
  loading: false,
  successMessage: null,
  errorPopupMessage: null,
  selectedNDCTab: NDC_TABS_DATA[1].value,
  searchByDrugNameTableData: [],
  labelerTableData: [],
  labelerDrugTableData: [],
  ndcDetailsTableData: [],
  ndcDetailsTableRowSelected: [],
  referenceData: null,
  generalSystemParameter: [],
  priceTypeDetails: [],
  ndcDetails: [],
  currentNDCDetailsIndex: 1,
  currentNDCDetailsSelected: null,
  ndcDetailsTabSelected: NDC_DETAILS_TAB_DATA[0].value,
  searchByDrugName: '',
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case TYPES.NDC_LOADING:
      return { ...state, loading: action.payload };
    case TYPES.NDC_GENERAL_PARAMETERS:
      return { ...state, generalSystemParameter: action.payload };
    case TYPES.NDC_SUCCESS_MESSAGE:
      return { ...state, successMessage: action.payload };
    case TYPES.NDC_ERROR_POPUP_MESSAGE:
      return { ...state, errorPopupMessage: action.payload };
    case TYPES.NDC_SELECTED_NDC_TAB:
      return { ...state, selectedNDCTab: action.payload };
    case TYPES.NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA:
      return { ...state, searchByDrugNameTableData: action.payload };
    case TYPES.NDC_LABELER_TABLE_DATA:
      return { ...state, labelerTableData: action.payload };
    case TYPES.NDC_LABELER_DRUG_TABLE_DATA:
      return { ...state, labelerDrugTableData: action.payload };
    case TYPES.NDC_DETAILS_TABLE_DATA:
      return { ...state, ndcDetailsTableData: action.payload };
    case TYPES.NDC_DETAILS_TABLE_ROW_SELECTED:
      return { ...state, ndcDetailsTableRowSelected: action.payload };
    case TYPES.NDC_DETAILS:
      return { ...state, ndcDetails: action.payload };
    case TYPES.NDC_DETAILS_TAB_SELECTED:
      return { ...state, ndcDetailsTabSelected: action.payload };
    case TYPES.CURRENT_NDC_DETAILS_SELECTED:
      let tempObj = { ...action.payload };
      if (
        action.payload?.cmsUroaVOs?.length > 0 &&
        (action?.dataType === 'All' || action?.dataType === 'cmsUroaVOs')
      ) {
        handleExistingCommentList(
          action.payload.cmsUroaVOs,
          null,
          'allList'
        ).then((res) => {
          tempObj.cmsUroaVOs = res;
        });
      }
      if (
        action.payload?.cmsCodStatusVOs?.length > 0 &&
        (action?.dataType === 'All' || action?.dataType === 'cmsCodStatusVOs')
      ) {
        handleExistingCommentList(
          action.payload.cmsCodStatusVOs,
          null,
          'allList'
        ).then((res) => {
          tempObj.cmsCodStatusVOs = res;
        });
      }
      if (
        action.payload?.cmsDesiVOS?.length > 0 &&
        (action?.dataType === 'All' || action?.dataType === 'cmsDesiVOS')
      ) {
        handleExistingCommentList(
          action.payload.cmsDesiVOS,
          null,
          'allList'
        ).then((res) => {
          tempObj.cmsDesiVOS = res;
        });
      }
      if (
        action.payload?.cmsDrugVOs?.length > 0 &&
        (action?.dataType === 'All' || action?.dataType === 'cmsDrugVOs')
      ) {
        handleExistingCommentList(
          action.payload.cmsDrugVOs,
          null,
          'allList'
        ).then((res) => {
          tempObj.cmsDrugVOs = res;
        });
      }

      return { ...state, currentNDCDetailsSelected: tempObj };
    case TYPES.CURRENT_NDC_DETAILS_INDEX:
      return { ...state, currentNDCDetailsIndex: action.payload };
    case TYPES.NDC_REFERENCE_DATA:
      return { ...state, referenceData: action.payload };
    case TYPES.PRICE_TYPE_DETAILS:
      return { ...state, priceTypeDetails: action.payload };
    case TYPES.SEARCH_BY_NDC_ID:
      return { ...state, searchByNDCId: action.payload };
    case TYPES.SET_NDC_SEARCH_BY_DRUG_NAME:
      return { ...state, searchByDrugName: action.payload };
    case TYPES.RESET_NDC_DATA:
      return {
        ...state,
        loading: false,
        successMessage: null,
        errorPopupMessage: null,
        selectedNDCTab: NDC_TABS_DATA[1].value,
        searchByDrugNameTableData: [],
        labelerTableData: [],
        labelerDrugTableData: [],
        ndcDetailsTableData: [],
        ndcDetailsTableRowSelected: [],
      };
    case TYPES.RESET_NDC_DETAILS_DATA:
      return {
        ...state,
        loading: false,
        successMessage: null,
        errorPopupMessage: null,
        priceTypeDetails: [],
        ndcDetails: [],
        currentNDCDetailsIndex: 1,
        currentNDCDetailsSelected: null,
        ndcDetailsTabSelected: NDC_DETAILS_TAB_DATA[0].value,
        referenceData: null,
        generalSystemParameter: [],
      };
    default:
      return state;
  }
};

export default reducer;
